import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-dots',
  templateUrl: './chat-loading.html',
  styleUrls: ['./chat-loading.scss'],
})
export class LoadingDotsComponent {}
